export const FAVOURITES_FEATURE_KEY = 'favourites';
